<div class="head">
  @for (item of timeList; track $index) {
    <span class="slot">{{ item | DateTime: 'TIME_SIMPLE' }}</span>
  }
</div>
